import { formatName } from '@leland-dev/leland-ui-library';
import React from 'react';

import OfferingPackagePage from '../../../components/package/OfferingPackagePage';
import NotFoundPage from '../../../components/page/NotFoundPage';

import {
  PublishedOfferingPackagePageGetOfferingPackageBySlugDocument,
  type PublishedOfferingPackagePageOfferingPackageFragment,
  usePublishedOfferingPackagePageGetOfferingPackageBySlugQuery,
} from './__generated-gql-types__/[packageSlug].generated';
interface PublishedOfferingPackagePageProps {
  offeringPackage: Possible<PublishedOfferingPackagePageOfferingPackageFragment>;
}

const PublishedOfferingPackagePage: React.FC<
  PublishedOfferingPackagePageProps
> = ({ offeringPackage }) => {
  const { data: clientData } =
    usePublishedOfferingPackagePageGetOfferingPackageBySlugQuery({
      variables: {
        coachSlug: offeringPackage?.coach.slug ?? '',
        packageSlug: offeringPackage?.slug ?? '',
      },
    });
  const offeringPackageToUse =
    clientData?.offeringPackageBySlug ?? offeringPackage;
  if (!offeringPackageToUse) {
    return <NotFoundPage entity="package" />;
  }
  const titleFragments = [
    `${offeringPackageToUse.name} by ${formatName(
      offeringPackageToUse.coach.user,
    )}`,
  ];
  if (offeringPackageToUse.category) {
    titleFragments.push(`${offeringPackageToUse.category.name} Package`);
  }

  return (
    <OfferingPackagePage
      offeringPackage={offeringPackageToUse}
      coachPackages={offeringPackageToUse.coach.packages}
      refetchQueries={[
        PublishedOfferingPackagePageGetOfferingPackageBySlugDocument,
      ]}
    />
  );
};

export default PublishedOfferingPackagePage;
